import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import PromocionAddComponents from "../../../../components/PromocionAddComponents";
import { useNavigate } from 'react-router-dom';



function AddPromocionPage() {
    const [cargando, setCargando] = useState(false);
    const [titulo, setTitulo] = useState('');
    const [activoStatus, setActivoStatus] = useState(false);
    const [mostrarAlLocatario, setMostrarAlLocatario] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    //ratio otros bancos
    const [ratioOtrosBancos, setRatioOtrosBancos] = useState('');
    //ratio para itau
    const [ratioItau, setRatioItau] = useState('');
    //ratio itau personal bank
    const [ratioItauPersonalBank, setRatioItauPersonalBank] = useState('');
    //porcentaje que absorve cada local
    const [porcentajeAbsorve, setPorcentajeAbsorve] = useState('');
    //monto minimo para comprar vales
    const [montoMinimo, setMontoMinimo] = useState('');
    //monto maximo para comprar vales
    const [montoMaximo, setMontoMaximo] = useState('');


    //fecha inicio comprar vales
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaInicioBackend, setFechaInicioBackend] = useState('');
    //fecha hasta comprar vales
    const [fechaHasta, setFechaHasta] = useState(null);
    const [fechaHastaBackend, setFechaHastaBackend] = useState('');

    //fecha inicio canjear vales
    const [fechaInicioCanjear, setFechaInicioCanjear] = useState(null);
    const [fechaInicioCanjearBackend, setFechaInicioCanjearBackend] = useState('');
    //fecha hasta canjear vales
    const [fechaHastaCanjear, setFechaHastaCanjear] = useState(null);
    const [fechaHastaCanjearBackend, setFechaHastaCanjearBackend] = useState('');

    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    const navigate = useNavigate();

    // console.log("info data", id);

    useEffect(() => {
        // handleListarProductos();
        setTimeout(() => {
            setCargando(true);
        }, 1000);
    }, []);




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //=========================================================funcion para guardar
    const handleGuardar = () => {
        let body = {};
        body.nombre = titulo;
        body.status = activoStatus ? "Activo" : "Inactivo";
        body.mostrarAlLocatario = mostrarAlLocatario;
        body.ratioOtrosBancos = ratioOtrosBancos;
        body.ratioItau = ratioItau;
        body.ratioItauPersonalBank = ratioItauPersonalBank;
        body.porcentajeAbsorve = porcentajeAbsorve;
        body.montoMinimo = montoMinimo;
        body.montoMaximo = montoMaximo;
        body.fechaInicioComprar = fechaInicioBackend;
        body.fechaHastaComprar = fechaHastaBackend;
        body.fechaInicioCanjear = fechaInicioCanjearBackend;
        body.fechaHastaCanjear = fechaHastaCanjearBackend;


        console.log("body", body);

        //validar campos que no esten vacios
        if (titulo.trim() === '' || fechaInicioBackend === '' || fechaHastaBackend === '' || fechaInicioCanjearBackend === '' || fechaHastaCanjearBackend === '' || ratioOtrosBancos === '' || ratioItau === '' || ratioItauPersonalBank === '' || porcentajeAbsorve === '' || montoMinimo === '' || montoMaximo === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Todos los campos son obligatorios');
        } else {

            setLoadingGuardar(true);


            setTimeout(() => {
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');

                    setTimeout(() => {
                        navigate('/app/admin/paseo-plus-promociones');
                    }, 1000);
                }, 1000);

            }, 2000);
        }
    };

    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaInicio = (event) => {
        // console.log("event", event);
        setFechaInicio(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaInicioBackend(fecha);
    };

    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaHasta = (event) => {
        // console.log("event", event);
        setFechaHasta(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaHastaBackend(fecha);
    };

    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaInicioCanjear = (event) => {
        // console.log("event", event);
        setFechaInicioCanjear(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaInicioCanjearBackend(fecha);
    };

    //=============================================funcion para seleccionar la fecha inicio
    const handleFechaHastaCanjear = (event) => {
        // console.log("event", event);
        setFechaHastaCanjear(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaHastaCanjearBackend(fecha);
    };


    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>

                <div style={{
                    backgroundColor: PaletaColor.BLANCO,
                    borderRadius: Padding.P1,
                    padding: Padding.P3,
                }}>
                    {cargando ? (
                        <div style={{}}>
                            <Typography variant={'h5'} style={{ marginBottom: Padding.P2 }}>
                                Crear Promoción - Paseo Plus
                            </Typography>

                            <PromocionAddComponents
                                titulo={titulo}
                                setTitulo={setTitulo}

                                mostrarAlLocatario={mostrarAlLocatario}
                                setMostrarAlLocatario={setMostrarAlLocatario}

                                activoStatus={activoStatus}
                                setActivoStatus={setActivoStatus}

                                ratioOtrosBancos={ratioOtrosBancos}
                                setRatioOtrosBancos={setRatioOtrosBancos}

                                ratioItau={ratioItau}
                                setRatioItau={setRatioItau}

                                ratioItauPersonalBank={ratioItauPersonalBank}
                                setRatioItauPersonalBank={setRatioItauPersonalBank}

                                porcentajeAbsorve={porcentajeAbsorve}
                                setPorcentajeAbsorve={setPorcentajeAbsorve}

                                montoMinimo={montoMinimo}
                                setMontoMinimo={setMontoMinimo}

                                montoMaximo={montoMaximo}
                                setMontoMaximo={setMontoMaximo}


                                handleCancelar={handleCancelar}
                                handleGuardar={handleGuardar}


                                //fecha inicio comprar vales
                                fechaInicio={fechaInicio}
                                handleFechaInicio={handleFechaInicio}

                                //fecha hasta comprar vales
                                fechaHasta={fechaHasta}
                                handleFechaHasta={handleFechaHasta}

                                //fecha inicio canjear vales
                                fechaInicioCanjear={fechaInicioCanjear}
                                handleFechaInicioCanjear={handleFechaInicioCanjear}

                                //fecha hasta canjear vales
                                fechaHastaCanjear={fechaHastaCanjear}
                                handleFechaHastaCanjear={handleFechaHastaCanjear}

                            />
                        </div>
                    ) : <SkeletonLoading />
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddPromocionPage;